module.exports = require("./sc.js");